module.exports = __webpack_public_path__ + "img/img9.52062d33.svg";